import { render, staticRenderFns } from "./SetupConfirmation.vue?vue&type=template&id=abb3c2e6&scoped=true"
import script from "./SetupConfirmation.vue?vue&type=script&lang=js"
export * from "./SetupConfirmation.vue?vue&type=script&lang=js"
import style0 from "./SetupConfirmation.vue?vue&type=style&index=0&id=abb3c2e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abb3c2e6",
  null
  
)

export default component.exports